import * as React from "react";
import { Switch } from "react-router-dom";
import { CreateSubjectScreen } from "./CreateSubjectScreen";
import { EditSubjectScreen } from "./EditSubjectScreen";
import { ViewSubjectScreen } from "./ViewSubjectScreen";
import { PrivateRoute } from "../Core/PrivateRoute";
import { PermissionEnum } from "../misc/api/ApiPermissionEnum";
import { SubjectsListScreen } from "./List/SubjectsListScreen";

export const SubjectsScreen = () => {
    return (
        <Switch>
            <PrivateRoute exact path="/Subjects" permissions={[PermissionEnum.ViewSubjects, PermissionEnum.ViewSiteSubjects, PermissionEnum.CreateSubject, PermissionEnum.EditSubject]}>
                <SubjectsListScreen />
            </PrivateRoute>
            <PrivateRoute exact path="/Subjects/Create" permissions={[PermissionEnum.CreateSubject, PermissionEnum.CreateSiteSubjects]}>
                <CreateSubjectScreen />
            </PrivateRoute>
            <PrivateRoute path="/Subjects/Edit/:id" permissions={[PermissionEnum.EditSubject, PermissionEnum.EditSiteSubjects]}>
                <EditSubjectScreen />
            </PrivateRoute>
            <PrivateRoute path="/Subjects/View/:id" permissions={[PermissionEnum.ViewSubjects, PermissionEnum.ViewSiteSubjects]}>
                <ViewSubjectScreen />
            </PrivateRoute>
        </Switch>
    );
}
